export default "__VITE_ASSET__BrulUikL__"